import React from 'react';
import ag from '../../../assets/images/icon.agri.png';
import contract from '../../../assets/images/icon.contractor.png';
import food from '../../../assets/images/icon.food.png';
import fuel from '../../../assets/images/icon.gas.png';
import home from '../../../assets/images/icon.home.png';
import pharma from '../../../assets/images/icon.pharm.png';
import socialResp from '../../../assets/images/icon.social-resp.png';
import commercialFuel from '../../../assets/images/icon.commercial.fuel.png';
import Contractor from './Contractor';
import Checkbox from '../../Common/Checkbox';

// Subscriptions form. It shows on the mail preferences page when user is subscribed.
const Subscriptions = (props) => {
    return (
        <div className={'prefs'}>
        <p className="red-bold">Please send me emails about these topics</p>
          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclFood" 
                checked={props.preferences.fclFood} 
                onChange={props.handleChange} 
                aria-label='Food' 
              />
            </div>
            <img src={food} alt="Food" />
            <div className="description">
            <strong>Food:</strong> Feel like a chef in your own kitchen with Co-op's popular recipes, products and meal ideas.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclHome" 
                checked={props.preferences.fclHome} 
                onChange={props.handleChange} 
                aria-label="Home and Building" 
              />
            </div>
            <img src={home} alt="Home and Building" />
            <div className="description">
            <strong>Home & Building:</strong> From our home to yours, find product information and tips for your next building project.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclPharmacy" 
                checked={props.preferences.fclPharmacy} 
                onChange={props.handleChange} 
                aria-label="Pharmacy" 
              />
            </div>
            <img src={pharma} alt="Pharmacy" />
            <div className="description">
            <strong>Pharmacy:</strong> We're more than just faces behind the counter. Feel healthy and at your best with advice from your local Co-op pharmacist.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclAg" 
                checked={props.preferences.fclAg} 
                onChange={props.handleChange} 
                aria-label="Agriculture" 
              />
            </div>
            <img src={ag} alt="Ag" />
            <div className="description">
            <strong>Agriculture:</strong> Grow, fuel, equip, build and feed your operation with offers and expert info from your trusted local Co-op Agro Team.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclFuel" 
                checked={props.preferences.fclFuel} 
                onChange={props.handleChange} 
                aria-label="Fuel" 
              />
            </div>
            <img src={fuel} alt="Fuel" />
            <div className="description">
            <strong>Fuel:</strong> From the daily commute to the weekend pursuit, find offers and info to keep you moving with ease.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclCommercialFuel" 
                checked={props.preferences.fclCommercialFuel} 
                onChange={props.handleChange} 
                aria-label="Commercial Fuel" 
              />
            </div>
            <img src={commercialFuel} alt="Commercial Fuel" />
            <div className="description">
            <strong>Commercial Fuel:</strong> Receive monthly emails on everything Co-op fuel for Commercial Customers. News, offers and articles on industry trends.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclSocialResponsibility" 
                checked={props.preferences.fclSocialResponsibility} 
                onChange={props.handleChange} 
                aria-label="Social responsibility" 
              />
            </div>
            <img src={socialResp} alt="Social Responsibility" />
            <div className="description">
            <strong>Social Responsibility:</strong> Co-op is committed to giving back to our communities. Stay up to date on what we’re doing to support local initiatives and organizations.
            </div>
          </div>

          <div className="row">
            <div className="check">
              <Checkbox 
                name="fclContractorsChoice" 
                checked={props.preferences.fclContractorsChoice} 
                onChange={props.handleChange} 
                aria-label="Contractor's choice" 
              />
            </div>
            <img src={contract} alt="Contractor choice" />
            <div className="description">
            <strong>Contractor’s Choice:</strong> Keep your clients smiling with level-headed advice and offers from your local Co‑op.
            </div>
          </div>

          {props.showContract ? <Contractor
            preferences = {props.preferences}
            handleContractorChoice = {props.handleContractorChoice}
            /> : ''
          }

          <div className="row research">
            <div className="check">
              <Checkbox 
                name="research" 
                checked={props.preferences.research} 
                onChange={props.handleChange} 
                aria-label="Research" 
              />
            </div>
            <div className="description">
            I'm willing to participate in research periodically to improve my local Co-op.
            </div>
          </div>
        </div>


        );
}

export default Subscriptions;